import React from "react";
import { useNavigate } from "react-router-dom";
import { AnimatedBackground } from "./AnimatedBackground";

export const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section
      id="join"
      data-testid="cta-section"
      className="relative isolate py-16 md:py-20 border-t border-white/10 overflow-hidden"
    >
      <AnimatedBackground variant="cta" intensity="soft" />

      <div className="relative mx-auto max-w-6xl px-6 md:px-10">
        {/* Eyebrow — metallic blue gradient text, standard divider lines */}
        <div className="flex items-center justify-center gap-3">
          <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
          <span
            className="font-mono-label section-eyebrow home-eyebrow"
            style={{ color: "#E8C97A", letterSpacing: "0.12em" }}
            data-testid="cta-eyebrow"
          >
            Get Started Today
          </span>
          <span className="h-px w-10" style={{ background: "linear-gradient(90deg, transparent, rgba(66,165,245,0.65), transparent)" }} />
        </div>

        <div className="mx-auto max-w-3xl text-center">
          <h2
            className="font-display mt-3 leading-[1.05]"
            style={{ fontSize: "clamp(1.75rem, 3vw, 2.5rem)" }}
            data-testid="cta-heading"
          >
            30 Day Free Trial
          </h2>
          <p className="mx-auto mt-4 max-w-3xl text-base md:text-lg leading-relaxed text-white/80" data-testid="cta-description">
            Get started today with EazyBot's 30 Day Free Trial! Our step-by-step setup videos will walk you through the process. If you need extra assistance, our Setup Team is here to help.
          </p>
        </div>

        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => navigate("/get-started")}
            className="btn-lift inline-flex items-center justify-center rounded-full px-8 py-3.5 text-sm font-semibold"
            style={{ background: "#D4A24C", color: "#141034", boxShadow: "0 8px 24px rgba(3,172,239,0.12)" }}
            data-testid="cta-setup-guide"
          >
            Setup Guide
          </button>
        </div>
      </div>
    </section>
  );
};
